import React from 'react';
import { Edit, Trash2 } from 'react-feather';

import './fees-mini-bar.styles.scss';
import { formatCurrency } from '../../../utils/common.util';
import { RenderIf } from '@/components/RenderIf';

const FeesMiniBar = ({
  fee: { id, amount, ledgerAccountDescription, classDescription },
  editAction,
  deleteAction,
}) => (
  <div className="fees-mini-bar">
    <div className="t-c text-truncate">
      <p className="name">
        {ledgerAccountDescription}
        {classDescription ? `, ${classDescription}` : ''}
      </p>
      <h3 className="value">{formatCurrency(amount)}</h3>
    </div>

    <div className="right">
      <RenderIf condition={editAction}>
        <span className="edit pointer" onClick={editAction}>
          <span className="icon-edit">
            <Edit color="#164D9D" size={15} />
          </span>
        </span>
      </RenderIf>
      &nbsp;&nbsp;
      <RenderIf condition={deleteAction}>
        <span className="delete pointer" onClick={deleteAction}>
          <Trash2 color="#DA1E28" size={15} />
        </span>
      </RenderIf>
    </div>
  </div>
);

export default FeesMiniBar;
